import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFarm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	"data-name": "Layer 1",
	viewBox: "0 0 24 24",
	height: "1.3em",
	width: "1.3em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23.496,8.766l-3.334-5.001c-.323-.485-.778-.864-1.314-1.094L13.181,.242c-.751-.321-1.612-.322-2.363,0L5.152,2.671c-.537,.23-.991,.608-1.314,1.093L.504,8.765c-.33,.495-.504,1.07-.504,1.665v13.57H24V10.43c0-.595-.174-1.17-.504-1.664Zm-9.917,9.325l3.421-2.799v5.598l-3.421-2.799Zm1.619,3.909h-6.397l3.199-2.617,3.199,2.617Zm-3.199-5.201l-3.421-2.799h6.842l-3.421,2.799Zm-5-1.507l3.421,2.799-3.421,2.799v-5.598Zm15,6.708h-3v-7c0-1.654-1.346-3-3-3H8c-1.654,0-3,1.346-3,3v7H2V10.43c0-.198,.058-.39,.168-.555l3.335-5.002c.107-.162,.259-.288,.438-.364l5.666-2.428c.251-.107,.538-.107,.788,0l5.666,2.428c.179,.077,.33,.203,.438,.365l3.334,5.002c.11,.165,.168,.356,.168,.554v11.57ZM12,4c-1.654,0-3,1.346-3,3s1.346,3,3,3,3-1.346,3-3-1.346-3-3-3Zm0,4c-.551,0-1-.449-1-1s.449-1,1-1,1,.449,1,1-.449,1-1,1Z" })
});
export default SvgFarm;
